import { CN_FONT_VERSION } from './fontVersion.js'

const CN_FONT_FAMILY = 'samt-sons-cn'
const CN_FONT_STYLE_ID = 'samt-cn-font-face-style'

const cnFontWeights = [
  { suffix: 'Thin', weight: 200 },
  { suffix: 'Light', weight: 300 },
  { suffix: 'Regular', weight: 400 },
  { suffix: 'Medium', weight: 500 },
  { suffix: 'Bold', weight: 700 },
  { suffix: 'Bold', weight: 900 }
]

const buildCnFontFaceBlock = ({ suffix, weight }) => {
  const base = `./assets/font/HarmonyOS_Sans_SC_${suffix}`
  return `
@font-face {
  font-family: '${CN_FONT_FAMILY}';
  src:
    url('${base}.ttf?v=${CN_FONT_VERSION}') format('truetype'),
    url('${base}.woff?v=${CN_FONT_VERSION}') format('woff');
  font-weight: ${weight};
  font-style: normal;
  font-display: swap;
}
`
}

export const initCnFontFaces = () => {
  if (typeof document === 'undefined') return
  if (document.getElementById(CN_FONT_STYLE_ID)) return

  const style = document.createElement('style')
  style.id = CN_FONT_STYLE_ID
  style.textContent = cnFontWeights.map(buildCnFontFaceBlock).join('\n')
  document.head.appendChild(style)
}
